export const workspace = {
  routes: [
    // TKP-67: amaçlar iki listede — işleme ve aktarım. Sınıflandırılmamış (kind=null) amaçlar ikisinde de görünür.
    {
      path: "/workspace/library/purpose",
      component: () => import("../workspace-library-purpose-view"),
      meta: { rules: [], purposeKind: "PROCESSING" },
    },
    {
      path: "/workspace/library/transfering-purpose",
      component: () => import("../workspace-library-purpose-view"),
      meta: { rules: [], purposeKind: "TRANSFERING" },
    },
    {
      path: "/workspace/library/legal-reason",
      component: () => import("../workspace-library-legal-reason-view"),
    },
    {
      path: "/workspace/library/legitimate-interest",
      component: () => import("../workspace-library-legitimate-interest-view"),
    },
  ],
};

export const management = {
  routes: [
    // TKP-67: bkz. çalışma alanı kütüphanesi — aynı ekran iki türü de gösterir.
  ],
};
